import { cloneDeep } from 'lodash';
// import {
//   callbackService
// } from '@/angularBridgeCode/ringbaPortal.servicesModule';

const columnSettings = {
  incomingQueryStringName: {
    name: 'incomingQueryStringName',
    sort: 'asc',
    defaultSort: 'asc',
    displayName: 'TABLE_HEADER_COL_URL_PARAMETER',
  },
  mapToTagType: {
    name: 'mapToTagType',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_REPORTING_MENU_NAME',
  },
  mapToTagName: {
    name: 'mapToTagName',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_REPORT_NAME'
  }
};

const defaultColumns = [
  'incomingQueryStringName',
  'mapToTagType',
  'mapToTagName'];

export default class UrlParameterService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.columnSettings = cloneDeep(columnSettings);
    this.defaultColumns = [...defaultColumns];
  }
  
  getUrlParameters(accountId) {
    let url = this.ngAuthSettings.apiServiceBaseUri + accountId + '/queryPathMaps';
    return this.$http.get(url);
  }

  getUrlParameter(accountId, queryPathMapId) {
    let url = this._serviceBaseUrl(accountId, queryPathMapId);
    return this.$http.get(url);
  }

  createUrlParameter(accountId, queryPathMap) {
    let url = this.ngAuthSettings.apiServiceBaseUri + accountId + '/queryPathMaps';
    return this.$http.post(url,queryPathMap);
  }

  getUrlParameterReferences(accountId, queryPathMapId) {
    let url = this._serviceBaseUrl(accountId, queryPathMapId) + '/InboundReferences';
    return this.$http.get(url);
  }

  deleteUrlParameter(accountId, queryPathMapId, force) {
    let url = this._serviceBaseUrl(accountId, queryPathMapId) + '?force=' + force;
    return this.$http.delete(url);
  }

  updateUrlParameter(accountId, queryPathMap) {
    let url = this._serviceBaseUrl(accountId, queryPathMap.id);
    return this.$http.patch(url, queryPathMap);
  }

  _serviceBaseUrl(accountId, queryPathMapId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/queryPathMaps/' + queryPathMapId;
  }
}